import { isTerminal } from "../../../../../../../constants";
import DropdownMenu from "../../../../../../common/Menu/DropdownMenu/DropdownMenu";
import CustomUploader from "../../../../../../common/CustomUploader/CustomUploader";
import DatePeriodControlled from "../../../../../../common/Inputs/DatePeriodControlled/DatePeriodControlled";
import {
    getReasonBelongsTypeThunkAction,
} from "../../../../../../../redux/actions/Requests/LeaveMetadata/thunk/getReasonBelongsType.thunk.action";
import {
    getRequestsForRescheduleThunkAction,
} from "../../../../../../../redux/actions/Requests/Postpone/thunk/getRequestsForReschedule.thunk.action";
import CommentInput from "../../../../../../common/Inputs/CommentInput/CommentInput";
import RequestsHelper from "../../../../../../../frontend.services/RequestServices/Requests.helper";
import {
    emptyCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/emptyCurrentRequest";
import PostponeVacationApplication from "../../../../../../../frontend.classes/Requests/PostponeVacation.application";
import {
    dropdownSelectionCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/dropdownSelection.currentRequest";
import {
    addCommentHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addCommentHandler.currentRequest";
import NotificationWindowRequests from "../../../../../../common/NotificationWindowRequests/NotificationWindowRequests";
import {
    isAttachmentsAllowedThunkAction,
    isAttachmentsAllowedWithReasonThunkAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/isAttachmentsAllowed.thunk.action";
import {
    clearAttachmentsAllowedAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/isAttachmentsAllowed.action";
import {
    saveDraftCurrentRequestThunk,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/saveDraft.currentRequest.thunk";
import {
    updateCurrentRequestThunk,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/update.currentRequest.thunk";
import {clearAttachmentsAction} from "../../../../../../../redux/actions/Requests/Attachments/clearAttachments.action";
import BlueButton from "../../../../../../common/Button/BlueButton/BlueButton";

import {
    addPeriodHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addPeriodHandler.currentRequest";

import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import React, {memo, useEffect, useState} from "react";

isTerminal ? import("./PostponeVacationTerminal.scss") : import("./PostponeVacation.scss");


const PostponeVacation = (
    {
        setRequestStatus,
        requestStatus,
        requestOption,
        setRequestState,
    }
) => {

    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();
    const queryId = searchParams.get("id");

    const reasons = useSelector(state => state.requests.reasons);
    const schedule = useSelector(state => state.requests.requestsToReschedule);
    const currentRequest = useSelector(state => state.requests.currentRequest);
    const isUserAttachmentsAllowed = useSelector(state => state.requests.isUserAttachmentsAllowed);
    const [notificationWindow, setNotificationWindow] = useState(false);

    function selectDropdown(event, element, stateProperty) {
        if(stateProperty === "leaveReasonId") {
            let result = false;
            result =dispatch(isAttachmentsAllowedWithReasonThunkAction(
                {
                    requestTypeId: requestOption ,
                    reasonTypeId: element.id,
                }
            ));
            if (result)
                result.then(() => {
                    if (!currentRequest.uid) {
                        dispatch(
                            saveDraftCurrentRequestThunk(
                                { ...currentRequest, leaveReasonId: element.id  },
                                null,
                                null,
                                null,
                                null,
                            ),
                        );
                    } else {
                        dispatch(
                            updateCurrentRequestThunk(
                                { ...currentRequest, leaveReasonId: element.id  },
                                null,
                                null,
                                null,
                            ),
                        );
                    }
                });
        }
        dispatch(dropdownSelectionCurrentRequest({event, element, stateProperty}));
    }

    function commentHandler(e) {
        dispatch(addCommentHandlerCurrentRequest(e.target.value));
    }
    function addPeriodHandler(e) {
        dispatch(addPeriodHandlerCurrentRequest());
    }
    useEffect(() => {
        setRequestStatus(false);
        dispatch(clearAttachmentsAction());
        dispatch(getRequestsForRescheduleThunkAction({option: "annual"}));
        dispatch(getReasonBelongsTypeThunkAction(requestOption));
        if (!queryId) {
            dispatch(emptyCurrentRequest
            (new PostponeVacationApplication
            ({
                leaveTypeId: 3,
                periods: [{dateFrom: null, dateTo: null}],
            })
            )
            );
            dispatch(isAttachmentsAllowedThunkAction({requestTypeId: requestOption }));
        } else {
            if (currentRequest && currentRequest?.leaveReasonId) {
                dispatch(isAttachmentsAllowedWithReasonThunkAction(
                    {
                        requestTypeId: currentRequest.leaveTypeId,
                        reasonTypeId: currentRequest.leaveReasonId,
                    }
                ));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return () => {
            dispatch(clearAttachmentsAction());
            dispatch(clearAttachmentsAllowedAction());
        };
    }, [queryId]);

    useEffect(() => {
        if (requestStatus && !requestStatus.isSuccess) {
            setNotificationWindow(true);
        }
    }, [requestStatus]);

    return (
        <section className='postpone-vacation'>
            <DropdownMenu
                visibleIndex={"35"}
                currentRequest={currentRequest}
                styleName={"reason"}
                label={<>Выберите причину отпуска <span className="required_text"> *</span></>}
                listOfOptions={reasons}
                stateProperty={"leaveReasonId"}
                isValidKey={currentRequest
                    && currentRequest.isValid
                    && currentRequest.isValid.leaveReasonId
                    ? currentRequest.isValid.leaveReasonId
                    : false}
                selectOptionClick={selectDropdown}/>
            {currentRequest && currentRequest.leaveReasonId &&
                <DropdownMenu
                    currentRequest={currentRequest}
                    styleName={"reason-second"}
                    label={<>Выберите период отпуска для переноса <span className="required_text"> *</span></>}
                    listOfOptions={schedule
                        && schedule.length
                        ? RequestsHelper.postponeDropdownFabric(schedule)
                        : [{name: "нет отпусков для переноса"}]}
                    stateProperty={"leaveRequestDwhId"}
                    selectOptionClick={selectDropdown}
                    isValidKey={currentRequest.isValid.leaveRequestDwhId}/>
            }
            {
                currentRequest
                && currentRequest.leaveRequestDwhId ?
                    (
                        currentRequest.periods && currentRequest.periods.length ?
                            currentRequest.periods.map(
                                (period, index) => {
                                    return (
                                        <DatePeriodControlled
                                            allowsMultipleDateRanges={true}
                                            setRequestState={setRequestState}
                                            periodsLength={currentRequest.periods.length}
                                            key={index}
                                            parentStyle={"postpone-vacation"}
                                            period={period}
                                            index={index}/>
                                    );

                                }) :
                            <div style={{display: "flex", gap: "15px"}}>
                                <h3 style={{fontSize: "15px"}}>Добавить даты нового  отпуска</h3>
                                <BlueButton
                                    parentStyle={"postpone-vacation"}
                                    handler={addPeriodHandler}
                                />
                            </div>
                    )
                    : null
            }
            <CommentInput
                maxLength={255}
                value={currentRequest && currentRequest.employeeComment}
                changeHandler={commentHandler}
                label={"Комментарий"}
                parentStyle={"postpone-vacation"}/>
            {
            isUserAttachmentsAllowed ?
                <CustomUploader /> : null
            }
            <NotificationWindowRequests
                notificationWindowStatus={requestStatus}
                setNotificationWindowStatus={setRequestStatus}
                notificationWindowStyle={notificationWindow}
                blockingMessages={true}
            />
        </section>
    );
};

export default memo(PostponeVacation);
